import { SxProps, Theme } from '@mui/material';

export const contentWrapperStyles: SxProps<Theme> = {
	p: 3,
};
